var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"primary-color fa fa-download pointer",attrs:{"title":"Download Template","aria-hidden":"true"},on:{"click":_vm.onClickcsvDownload}})
}
var staticRenderFns = []

export { render, staticRenderFns }